import type { ExtraServiceReservation } from '../../../common/validations/extraServiceReservationSchema'

export const generateExtraServiceReservationName = (
  reservation: ExtraServiceReservation,
  type: 'storage' | 'right_of_access'
): { name: string; needsGymPrefix: boolean } => {
  const displayId =
    reservation.calendarMeta.realPropertyArea ??
    String(reservation.rentableHierarchyId ?? '')

  if (type === 'right_of_access') {
    // Gym reservations: return address, component will add translated "Gym" prefix
    const address = [
      reservation.calendarMeta.streetName,
      reservation.calendarMeta.streetNumber,
    ]
      .filter(Boolean)
      .join(' ')
      .trim()

    return { name: address, needsGymPrefix: true }
  }

  // Storage reservations: use existing logic
  const name =
    [
      reservation.calendarMeta.additionalDetails,
      reservation.calendarMeta.realPropertyArea,
    ]
      .filter(Boolean)
      .join(' ')
      .trim() || displayId

  return { name, needsGymPrefix: false }
}
